'use es6';

import * as assetsClient from 'DesignData/api/finder/Assets';
import * as tabsActions from 'DesignData/actions/Tabs';
import * as folderActions from 'DesignData/actions/finder/Folders';
import * as DesignAssetTypes from 'DesignData/enums/DesignAssetTypes';
import FileModel from 'DesignData/models/finder/File';
import { revealInFinder } from 'DesignData/actions/finder/Selections';
import { FINDER_ASSETS_SEARCH_FETCH, FINDER_FILES_RECENTLY_DELETED_FETCH, FINDER_FILES_RECENTLY_EDITED_FETCH, FINDER_SHOW_RECENTLY_EDITED, FINDER_SHOW_RECENTLY_DELETED, FINDER_ASSETS_SEARCH_SELECT_ASSET } from 'DesignData/actions/ActionTypes';
import { getSearchResultsAssetIds, getActiveSearchResultAsset, getFile } from 'DesignData/selectors/finder';
import { FOLDER } from 'DesignData/constants/FolderAssetTypes';
import { formatPathAsId } from 'DesignData/lib/text';
export function assetSearchSelectNextAsset(reverse = false) {
  return (dispatch, getState) => {
    const state = getState();
    const searchResults = getSearchResultsAssetIds(state);
    dispatch({
      type: FINDER_ASSETS_SEARCH_SELECT_ASSET,
      searchResults,
      reverse
    });
  };
}
export function openSearchResultActiveAsset() {
  return (dispatch, getState) => {
    const state = getState();
    const activeAsset = getActiveSearchResultAsset(state);

    if (!activeAsset) {
      return;
    } else if (activeAsset instanceof FileModel) {
      const tabObject = {
        id: activeAsset.id,
        assetType: DesignAssetTypes[activeAsset.type]
      };
      dispatch(folderActions.openDeeplyNestedFolder(activeAsset.folderId));
      dispatch(tabsActions.openTabObject(tabObject));
    } else {
      dispatch(folderActions.openDeeplyNestedFolder(activeAsset.id));
      dispatch(revealInFinder(activeAsset.id));
    }
  };
}
export function openRecentlyEdited() {
  return {
    type: FINDER_SHOW_RECENTLY_EDITED,
    show: true
  };
}
export function closeRecentlyEdited() {
  return {
    type: FINDER_SHOW_RECENTLY_EDITED,
    show: false
  };
}
export function openRecentlyDeleted() {
  return {
    type: FINDER_SHOW_RECENTLY_DELETED,
    show: true
  };
}
export function closeRecentlyDeleted() {
  return {
    type: FINDER_SHOW_RECENTLY_DELETED,
    show: false
  };
}
/**
 * GET designmanagersearch/v1/search/paginated?limit=25&searchTerm=&portalId=&offset=
 */

export function searchAssets(__searchTerm, offset = 0) {
  const {
    request,
    receive,
    error
  } = searchAssets;

  const searchTerm = __searchTerm.trim();

  return (dispatch, getState) => {
    dispatch(request(searchTerm, offset));
    const state = getState();
    const assetsRequest = assetsClient.searchAssetsEs(searchTerm, offset);
    return assetsRequest.then(response => {
      let __assets = [];

      if (response.objects) {
        __assets = response.objects.map(asset => {
          if (asset.path && !asset.id) {
            asset.id = formatPathAsId(asset.path);
          }

          if (asset.type !== FOLDER && !asset.folderPath) {
            const file = getFile(state, {
              fileId: asset.id || formatPathAsId(asset.path)
            });

            const __folderPath = file && file.__folderPath;

            return Object.assign({}, asset, {
              folderPath: __folderPath
            });
          }

          return asset;
        });
      }

      const responseOffset = response.offset;
      const total = response.total;
      const assets = __assets;
      dispatch(receive(searchTerm, responseOffset, total, assets));
    }).catch(__error => {
      dispatch(error(searchTerm, __error));
    });
  };
}

searchAssets.request = (searchTerm, offset) => {
  return {
    type: FINDER_ASSETS_SEARCH_FETCH,
    searchTerm,
    offset
  };
};

searchAssets.receive = (searchTerm, offset, total, assets) => {
  return {
    type: FINDER_ASSETS_SEARCH_FETCH,
    searchTerm,
    offset,
    total,
    assets
  };
};

searchAssets.error = (searchTerm, error) => {
  return {
    type: FINDER_ASSETS_SEARCH_FETCH,
    searchTerm,
    error
  };
};
/**
 * GET designmanager/v1/assets/recent/deleted
 */


export function fetchRecentlyDeleted() {
  const {
    request,
    receive,
    error
  } = fetchRecentlyDeleted;
  return dispatch => {
    dispatch(request());
    return assetsClient.fetchRecentlyDeleted().then(files => {
      dispatch(receive(files));
    }).catch(__error => {
      dispatch(error(__error));
    });
  };
}

fetchRecentlyDeleted.request = () => {
  return {
    type: FINDER_FILES_RECENTLY_DELETED_FETCH
  };
};

fetchRecentlyDeleted.receive = files => {
  return {
    type: FINDER_FILES_RECENTLY_DELETED_FETCH,
    files
  };
};

fetchRecentlyDeleted.error = error => {
  return {
    type: FINDER_FILES_RECENTLY_DELETED_FETCH,
    error
  };
};
/**
 * GET designmanager/v1/assets/recent
 */


export function fetchRecentlyEdited() {
  const {
    request,
    receive,
    error
  } = fetchRecentlyEdited;
  return dispatch => {
    dispatch(request());
    return assetsClient.fetchRecentlyEdited().then(files => {
      dispatch(receive(files));
    }).catch(__error => {
      dispatch(error(__error));
    });
  };
}

fetchRecentlyEdited.request = () => {
  return {
    type: FINDER_FILES_RECENTLY_EDITED_FETCH
  };
};

fetchRecentlyEdited.receive = files => {
  return {
    type: FINDER_FILES_RECENTLY_EDITED_FETCH,
    files
  };
};

fetchRecentlyEdited.error = error => {
  return {
    type: FINDER_FILES_RECENTLY_EDITED_FETCH,
    error
  };
};